export const navbarSizeInt = 64;
export const navbarSizeStr = `${navbarSizeInt}px`;
export const fullNavPanelWidthInt = 400;
export const fullNavPanelWidthStr = `${fullNavPanelWidthInt}px`;
